import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import classnames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { fetchAssessment } from "../../store/assessments/action";
import { getResultByTestId } from "../../store/results/action";
import "./ResultsDashboard.scss";

// Components for badges
const StatusBadge = ({ pass }) => (
  <Badge color={pass ? "success" : "danger"}>
    {pass ? "Passed" : "Failed"}
  </Badge>
);

const TopBadge = ({ top }) =>
  top && <Badge className="custom-badge">Top 5%</Badge>;

const ResultsDashboard = () => {
  const [activeTab, setActiveTab] = useState("Candidates");
  const { testId } = useParams();
  const dispatch = useDispatch();
  const assessmentDetails = useSelector(
    (state) => state?.AssessmentsReducer?.assessment
  );
  const resultsDetails = useSelector((state) => state?.ResultsReducer?.results);

  useEffect(() => {
    dispatch(fetchAssessment({ id: testId }));
    dispatch(getResultByTestId({ id: testId }));
  }, []);

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="page-content">
      <Container fluid>
        {/* Header Card */}
        <Card className="header-card">
          <CardBody className="p-0">
            <div
              className="d-flex flex-row justify-content-center align-items-center"
              style={{ gap: "12px" }}
            >
              <div
                className="d-flex align-items-start flex-column"
                style={{ width: "100%" }}
              >
                <div className="mb-auto p-0">
                  <div className="d-flex align-items-center gap-2">
                    <Badge className="first-badge">JSG9176193930</Badge>
                    <Badge className="second-badge">Java Developer</Badge>
                  </div>
                </div>
                <span style={{ fontSize: "18px" }}>
                  {assessmentDetails?.assessmentName}
                </span>
              </div>
              {/*<div className="d-flex p-0 m-0 align-items-right align-items-center gap-3">*/}

              <div className="d-flex align-items-center flex-row date-info">
                <div
                  className="mdi mdi-calendar-blank-outline fs-6"
                  style={{ color: "#C1C1C1" }}
                ></div>
                <div
                  className="d-flex flex-row"
                  style={{
                    fontSize: "12px",
                    color: "#2D313E",
                    whiteSpace: "nowrap",
                  }}
                >
                  {/* {formatDate(assessmentDetails?.startTime)} */}
                </div>
              </div>

              <Card
                className="info-card"
                style={{ minWidth: "110px", minHeight: "32px" }}
              >
                <CardBody className="p-0">
                  <div
                    className="d-flex align-items-center justify-content-center flex-row"
                    style={{ gap: "6px" }}
                  >
                    <div
                      className="mdi mdi-text-box-check-outline"
                      style={{ fontSize: "14px", color: "#3F88E4" }}
                    ></div>
                    <div style={{ fontSize: "14px", color: "#3F88E4" }}>10</div>
                    <div style={{ fontSize: "12px", color: "#2D313E" }}>
                      Reports
                    </div>
                  </div>
                </CardBody>
              </Card>

              <Card
                className="info-card"
                style={{ minWidth: "99px", minHeight: "32px" }}
              >
                <CardBody className="p-0">
                  <div
                    className="d-flex align-items-center justify-content-center flex-row"
                    style={{ gap: "6px" }}
                  >
                    <div
                      className="mdi mdi-timer-outline"
                      style={{ fontSize: "14px", color: "#3F88E4" }}
                    ></div>
                    <div style={{ fontSize: "14px", color: "#3F88E4" }}>
                      {assessmentDetails?.durationHr}:
                      {assessmentDetails?.durationMin}
                    </div>
                    <div style={{ fontSize: "12px" }}>min</div>
                  </div>
                </CardBody>
              </Card>

              {[
                "mdi mdi-link",
                "mdi mdi-account-multiple-plus",
                "mdi mdi-inbox-arrow-down-outline",
                "mdi mdi-pencil-outline",
              ].map((iconClass, index) => (
                <div key={index} className="d-flex align-items-center">
                  <button className="btn btn-primary icon-button">
                    <span
                      className={iconClass}
                      style={{ fontSize: "20px" }}
                    ></span>
                  </button>
                </div>
              ))}
              {/*</div>*/}
            </div>
            <div className="d-flex align-items-center gap-2 text-muted">
              <span>Java Developer</span>
              <span>|</span>
              <span>1 candidate taking</span>
              <span>|</span>
              <span>10 completed</span>
              <span>|</span>
              {/* <span>Expires on {formatDate(assessmentDetails?.expiryDate)}</span> */}
            </div>
          </CardBody>
        </Card>

        {/* Tabs Navigation */}
        <Nav
          tabs
          className="mb-4"
          style={{ borderBottom: "1px solid #CED2D8" }}
        >
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "QuestionBank" })}
              onClick={() => toggleTab("QuestionBank")}
              style={{ cursor: "pointer" }}
            >
              Question Bank
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "Candidates" })}
              onClick={() => toggleTab("Candidates")}
              style={{ cursor: "pointer" }}
            >
              Candidates
            </NavLink>
          </NavItem>
        </Nav>

        {/* Tab Content */}
        {activeTab === "Candidates" && (
          <Row>
            {resultsDetails && resultsDetails.length > 0 ? (
              resultsDetails.map((result, index) => {
                return (
                  <Col lg={12} key={index}>
                    <Card className="candidate-card">
                      <CardBody className="d-flex flex-row justify-content-between p-0 gap-4">
                        <div
                          className="d-flex flex-row gap-2 justify-content-between align-items-center"
                          style={{ width: "100%" }}
                        >
                          <div
                            className="d-flex align-items-center"
                            style={{ width: "100%", gap: "36px" }}
                          >
                            <div
                              className="d-flex align-items-center"
                              style={{ width: "100%" }}
                            >
                              <div
                                className="d-flex flex-column align-items-start"
                                style={{ width: "310px" }}
                              >
                                <div className="d-flex align-items-center gap-2">
                                  <span className="candidate-title">
                                    {
                                      result?.candidateId
                                        ?.candidateSubmissionData?.firstName
                                    }{" "}
                                    {
                                      result?.candidateId
                                        ?.candidateSubmissionData?.lastName
                                    }
                                  </span>
                                  <StatusBadge pass={result.pass} />
                                </div>
                                <div className="d-flex text-muted gap-2">
                                  <span>
                                    Phone:{" "}
                                    {
                                      result?.candidateId
                                        ?.candidateSubmissionData?.phone
                                    }
                                  </span>
                                  <span>|</span>
                                  <span>
                                    Mail ID:{" "}
                                    {
                                      result?.candidateId
                                        ?.candidateSubmissionData?.email
                                    }
                                  </span>
                                </div>
                              </div>
                            </div>

                            <TopBadge top={result?.score} />
                          </div>

                          <Card
                            className="info-card"
                            style={{ minWidth: "59px", minHeight: "29px" }}
                          >
                            <CardBody className="p-0">
                              <div
                                className="d-flex flex-row justify-content-center align-items-center"
                                style={{ gap: "6px" }}
                              >
                                <div
                                  style={{ fontSize: "14px", color: "#3F88E4" }}
                                >
                                  {result?.score}
                                </div>
                                <div style={{ fontSize: "12px" }}>/20</div>
                              </div>
                            </CardBody>
                          </Card>

                          <Card
                            className="info-card"
                            style={{ minWidth: "99px", minHeight: "32px" }}
                          >
                            <cardBody className="p-0">
                              <div
                                className="d-flex flex-row justify-content-center align-items-center"
                                style={{ gap: "6px" }}
                              >
                                <div
                                  className="mdi mdi-timer-outline"
                                  style={{
                                    fontSize: "15px",
                                    color: result.pass ? "#3F88E4" : "#00B91F",
                                  }}
                                ></div>
                                <div
                                  style={{
                                    fontSize: "14px",
                                    color: result.pass ? "#3F88E4" : "#00B91F",
                                  }}
                                >
                                  {result.timeTaken}
                                </div>
                                <div style={{ fontSize: "12px" }}>min</div>
                              </div>
                            </cardBody>
                          </Card>
                        </div>

                        <span
                          className="chevron-icon mdi mdi-chevron-right"
                          style={{ color: "#3F88E4" }}
                        ></span>
                      </CardBody>
                    </Card>
                  </Col>
                );
              })
            ) : (
              <span className="text-muted">
                No candidates have taken this assessment yet.
              </span>
            )}
          </Row>
        )}

        {activeTab === "QuestionBank" && (
          <div>
            <h3>Question Bank</h3>
            <p>Content for the Question Bank tab goes here.</p>
          </div>
        )}
      </Container>
    </div>
  );
};

export default ResultsDashboard;
